import React, { useState, useContext, useEffect, useRef } from "react";
import { IProps, IState, IImageList } from "./types";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "@utils/DOIgnition/AuthContext";
import { Context } from "@routes/private/Editor/Context";
import {
  storageAccountName,
  containerName,
  containerNameBrands,
} from "@storage/azure-storage-blob";
import {
  hasAtLeastOneElementType,
  findElementById
} from "@utils/editor";
import {
  IElement,
  IImageAttributes,
} from "@routes/private/Editor/types";
import * as S from "./styles";
import C from "@assets/themes/colors";
import Button from "@components/Button";
import OptionIcon from "@assets/icons/optionIcon";
import Tabs from "@components/Tabs";
import DragElement from "../DragElement";
import UploadBar from "@components/UploadBar";
import DealerSelect from "@components/DealerSelect";
import { MediaGallery } from "@components/MediaGallery";
import selectors from "@state/selectors";
import { TrashIcon } from "@assets/icons/trashicon";
import { getBoundingsWithDelta } from "@utils/geometry";
import SearchImages from "../SimilarImages/SearchImages";
import { IBrandImage } from "@state/brandsImages/types";
import actions from "@state/actions";
import { getWidthHeightFromSrc } from "@utils/userUtils";
import DeleteConfirmationModal from "./components/DeleteConfirmationModal";
import { useClipboardPaste } from "@utils/clipboard";
import {
  addNewFiles,
  handleAddImage,
  handleAddImageManager,
  updateImageList,
  validateFiles,
} from "./utils/imageUtils";
import { set } from "lodash";

const uuid = require("react-uuid");

const TabOptions = ["My Images", "Media Gallery"];
const imageFileTypes = ["image/png", "image/jpeg", "image/svg+xml"];

const ImagePicker: React.FC<IProps> = (props) => {
  const authContext = useContext(AuthContext);
  const context = useContext(Context);
  const dispatch = useDispatch();
  const [panelValue, setPanelValue] = useState("My Images");
  const [galleryPanel, setGalleryPanel] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [filesUploaded, setFilesUploaded] = useState<IState["files"]>([]);
  const [filesUrl, setFilesUrl] = useState<string[]>([]);
  const [filesResponse, setFileResponse] = useState<IState["response"]>();
  const [imageList, setImageList] = useState<IImageList[]>([]);
  const [imageListFiltered, setImageListFiltered] = useState<IImageList[]>([]);
  const [showMediaGallery, setShowMeadiaGallery] = useState(false);
  const [replace, setReplace] = useState(false);
  const [newImageSrc, setNewImageSrc] =
    useState<IState["newImageSrc"]>(undefined);
  const [loadingImage, setLoadingImage] = useState(false);
  const urlBrand = `https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;
  const urlFiles = `https://${storageAccountName}.blob.core.windows.net/${containerName}`;
  const deltaBorder = 0;
  let { editorStatus, onShowSearchImages } = useContext(Context);
  const [selectedImages, setSelectedImages] = useState<string[] | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isFromClipboard, setIsFromClipboard] = useState<boolean>(false);
  const [externalImageId, setExternalImageId] = useState<string | undefined>(undefined);

  // // USE CLIPBOARD FROM COPY/PASTE
  /*useClipboardPaste((file) => {
    if (file) {
      setIsFromClipboard(true);
      validateFiles([file], imageFileTypes, setFilesUploaded, context);
      setReplace(false);
    }
  });*/

  useEffect(() => {
    if (context.editorStatus.clipboardExternalImage && !context.editorStatus.externalImageLoaded) {
      setIsFromClipboard(true);
      validateFiles(
        [context.editorStatus.clipboardExternalImage],
        imageFileTypes,
        setFilesUploaded,
        context
      );
      setReplace(false);
    }
    
  },[context.editorStatus.clipboardExternalImage])

  useEffect(() => {
    const draggingData = context.editorStatus.draggingData;
    if (draggingData?.type === "Image") {
      handleAddDropImage(
        draggingData.id,
        draggingData.containerId,
        draggingData.coorsPercentage,
        draggingData.elementCoorsPercentage
      );
    }
  }, [context.editorStatus.draggingData]);

  useEffect(() => {
    if (newImageSrc) {
      context.onCommandChange(
        "srcImage",
        undefined,
        newImageSrc.ids,
        newImageSrc.values,
        false,
        undefined,
        false
      );
      setNewImageSrc(undefined);
    }
  }, [newImageSrc]);

  useEffect(() => {
    if (
      !hasAtLeastOneElementType(
        context.editorStatus.selectedElementsId,
        context.data,
        "Image"
      ) &&
      replace
    ) {
      context.onShowPicker(undefined);
    }
  }, [
    context.editorStatus.selectedElementsId,
    context.editorStatus.selectedElementsId.length,
  ]);

  const dealers = useSelector(selectors.dealers.getDealers);

  useEffect(() => {
    if (dealers.selectedDealer) setShowMeadiaGallery(true);
  }, [dealers.selectedDealer]);

  useEffect(() => {
    setReplace(
      context.editorStatus.currentPicker === "ReplaceImage" ||
        props.multiediting
        ? true
        : false
    );
  }, [context.editorStatus.currentPicker]);

  let fileInputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    if (galleryPanel === false) setOpenOptions(false);
  }, [galleryPanel]);

  useEffect(() => {
    if (filesUploaded.length > 0)
      addNewFiles(
        filesUploaded,
        "LOCAL",
        context,
        authContext,
        imageList,
        setImageList,
        dispatch,
        setFileResponse
      );
      //context.clearExternalImages();
  }, [filesUploaded]);

  //to load files from URLs
  useEffect(() => {
    if (filesUrl.length > 0)
      addNewFiles(
        filesUrl,
        "URL",
        context,
        authContext,
        imageList,
        setImageList,
        dispatch,
        setFileResponse
      );
  }, [filesUrl]);

  useEffect(() => {
    if (context.userFiles)
      updateImageList(context.userFiles?.files, setImageList);
  }, []);

  useEffect(() => {
    if (imageList?.length) updateImageList(imageList, setImageList);
  }, [panelValue]);

  useEffect(() => {
    if (filesResponse)  
    {
      updateImageList(imageList, setImageList, filesResponse.name, "uploaded");  
      if (isFromClipboard)
      {
        const name = filesResponse.name.split("/")[1];        
        setExternalImageId(name);
      }
    }

  }, [filesResponse]);

  useEffect(() => {
    const type = panelValue === "My Images" ? "image" : "image/gallery";
    setImageListFiltered(
      [...imageList]
        .filter((image) => image.type === type)
        .sort((a, b) => {
          return new Date(b.date).valueOf() - new Date(a.date).valueOf();
        })
    );
  }, [imageList, imageList.length]);

  
  // PASTE AUTOMATICALLY IN CANVAS
  useEffect(() => {
    if (isFromClipboard && imageListFiltered.length > 0 && externalImageId) {                  
      setTimeout(() => {
        handleAddImageManager(
          externalImageId,
          replace,
          context,
          deltaBorder,
          imageListFiltered,
          setNewImageSrc,
          dispatch
        );        
      }, 1000);
      setIsFromClipboard(false);
      setExternalImageId(undefined);   
      context.onExternalImageLoaded();
    }
  }, [isFromClipboard, imageListFiltered]);

  const updateImageOver = (imagesListFrom: IImageList[], fileName?: string) => {
    let newImageList = [...imagesListFrom];
    const oldImageIndex = newImageList.findIndex(
      (image) => image.isOver === true
    );
    if (oldImageIndex >= 0) {
      newImageList = [
        ...newImageList.slice(0, oldImageIndex),
        { ...newImageList[oldImageIndex], isOver: false },
        ...newImageList.slice(oldImageIndex + 1),
      ];
    }
    const newImageIndex = newImageList.findIndex(
      (image) => image.id === fileName
    );
    if (newImageIndex >= 0) {
      newImageList = [
        ...newImageList.slice(0, newImageIndex),
        { ...newImageList[newImageIndex], isOver: true },
        ...newImageList.slice(newImageIndex + 1),
      ];
    }
    setImageList(newImageList);
  };

  const deleteFiles = async (file: any) => {
    if (context.userFiles) {
      let newUserFiles = context.userFiles;
      newUserFiles.files = newUserFiles.files.filter((f) => f.id !== file);
      context.onEditUserFiles(newUserFiles);
      setImageList(imageList.filter((f) => f.id !== file));
    }
  };

  const deleteBulkFiles = async (files: string[] | null) => {
    if (!files || files.length === 0) {
      return;
    }
    if (context.userFiles) {
      let newUserFiles = context.userFiles;
      newUserFiles.files = newUserFiles.files.filter(
        (f) => !files.includes(f.id)
      );
      context.onEditUserFiles(newUserFiles);
      setImageList(imageList.filter((f) => !files.includes(f.id)));
    }
    setIsModalOpen(false);
  };

  const handleSelectAllImages = (e: any) => {
    setSelectedImages((prevSelected) => {
      if (e.target.checked) {
        return imageList.map((img) => img.id);
      } else {
        return [];
      }
    });
  };

  const handleUploadFile = () => {
    if (fileInputRef.current) (fileInputRef.current as any).click();
  };

  const handleUploadFromPanel = () => {
    handleUploadFile();
    handleOpenOptions();
  };

  const handleOpenOptions = () => {
    setOpenOptions(!openOptions);
  };

  const ondrop = (e: any) => {
    setDragging(false);
    if (e.dataTransfer && e.dataTransfer.files.length > 0) {
      validateFiles(
        e.dataTransfer.files,
        imageFileTypes,
        setFilesUploaded,
        context
      );
    }
    e.target.value = "";
  };

  const onInputFileChange = (e: any) => {
    if (fileInputRef.current) {
      validateFiles(
        (fileInputRef.current as any).files,
        imageFileTypes,
        setFilesUploaded,
        context
      );
    }
    e.target.value = "";
  };

  const handleImageLoad = (
    e: React.SyntheticEvent<HTMLImageElement, Event>,
    id: string,
    iWidth: number | undefined,
    iHeight: number | undefined
  ) => {
    const ratioTrigger = 2;
    const target = e.target as HTMLImageElement;
    const initWidth = iWidth ?? target.width ?? target.naturalWidth,
      initHeight = iHeight ?? target.height ?? target.naturalHeight;
    let width = initWidth,
      height = initHeight;
    const ratio = height > 0 ? width / height : ratioTrigger;
    if (ratio >= ratioTrigger) {
      width = 215;
      height = width / ratio;
    } else {
      width = 100;
      height = width / ratio;
    }
    const imageIndex = imageList.findIndex((image) => image.id === id);
    if (imageIndex >= 0) {
      setImageList([
        ...imageList.slice(0, imageIndex),
        {
          ...imageList[imageIndex],
          width: width,
          height: height,
          initWidth,
          initHeight,
        },
        ...imageList.slice(imageIndex + 1),
      ]);
    }
  };

  const handleAddDropImage = (
    itemId: string,
    id?: string,
    coors?: { x: number; y: number },
    elementCoors?: { x: number; y: number }
  ) => {
    const selectedArtboards: string[] = context.editorStatus.selectedArtboardIds
      ? context.editorStatus.selectedArtboardIds
      : [];
    const idIndex = selectedArtboards.findIndex(
      (artBoardId: string) => artBoardId === id
    );
    if (id) {
      if (idIndex >= 0) {
        if (selectedArtboards.length === 1)
          handleAddImage(
            [id],
            itemId,
            imageListFiltered,
            deltaBorder,
            context,
            setNewImageSrc,
            dispatch,
            coors,
            elementCoors
          );
        else
          handleAddImageManager(
            itemId,
            replace,
            context,
            deltaBorder,
            imageListFiltered,
            setNewImageSrc,
            dispatch
          );
      } else {
        context.onSelectedArtboardChange(id);
        handleAddImage(
          [id],
          itemId,
          imageListFiltered,
          deltaBorder,
          context,
          setNewImageSrc,
          dispatch,
          coors,
          elementCoors
        );
      }
    } else {
      handleAddImage(
        [context.data[0].id],
        itemId,
        imageListFiltered,
        deltaBorder,
        context,
        setNewImageSrc,
        dispatch,
        coors,
        elementCoors
      );
    }
  };

  const handleUploadFromBrandLibrary = () => {
    setLoadingImage(false);
    handleOpenOptions();
    context.onShowSearchImages(true);
  };

  const toggleImageSelection = (id: string) => {
    setSelectedImages((prevSelected) => {
      if (!prevSelected) return [id];

      return prevSelected.includes(id)
        ? prevSelected.filter((imgId) => imgId !== id)
        : [...prevSelected, id];
    });
  };

  const renderListComponent = (image: IImageList, index: number) => {
    if (!image || !image.id) return null;
    const urlImg = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${context.userFiles.id}/${image.id}`;
    return (
      <S.ListComponentContainer
        key={index}
        onMouseEnter={(e) => updateImageOver(imageList, image.id)}
      >
        <S.CheckboxContainer>
          <input
            type="checkbox"
            checked={selectedImages?.includes(image.id)}
            onChange={() => toggleImageSelection(image.id)}
          />
        </S.CheckboxContainer>
        <S.ListComponent
          onClick={() =>
            handleAddImageManager(
              image.id,
              replace,
              context,
              deltaBorder,
              imageListFiltered,
              setNewImageSrc,
              dispatch
            )
          }
          opacityValue={
            image.width && image.height
              ? "1"
              : image.status === "uploading"
              ? "0.75"
              : "0"
          }
          positionValue={image.width && image.height ? "auto" : "absolute"}
          zIndexValue={image.width && image.height ? "auto" : "0"}
          src={image.src ?? urlImg}
          onLoad={(e) =>
            handleImageLoad(e, image.id, image.initWidth, image.initHeight)
          }
          width={image.width}
          height={image.height}
        />
        {image.status === "uploading" && (
          <S.ProgressContainer
            widthValue={image.width ? `${image.width + 10}px` : `100px`}
          >
            <UploadBar
              width={image.width ? image.width * 0.8 : 80}
              height={6}
              progress={50}
            />
          </S.ProgressContainer>
        )}
        {image.isOver && (
          <S.TrashButton onClick={() => deleteFiles(image.id)}>
            <TrashIcon />
          </S.TrashButton>
        )}
      </S.ListComponentContainer>
    );
  };

  ///Brand Images select functions
  const handleSelectImage = async (data: IBrandImage) => {
    try {
      if (
        data.srcImage.startsWith("http") &&
        !data.srcImage.startsWith(urlFiles)
      )
        getImage(data);
      else {
        let srcFileOrg = `${urlBrand}/${data.brandId}/${
          data.imageType ? data.imageType.toLowerCase() : ""
        }/${data.srcImage}`;
        const dimensionsOrg = await getWidthHeightFromSrc(srcFileOrg ?? "");
        if (dimensionsOrg) {
          data.initWidth = dimensionsOrg.width;
          data.initHeight = dimensionsOrg.height;
        }
        handleAddBrandImageManager(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddBrandImageManager = (imageBrandInfo: IBrandImage) => {
    if (replace) {
      handleReplaceBrandImage(imageBrandInfo);
      return;
    }

    let ids: string[] = [];
    if (context.data[0].type === "Artboards") {
      if (
        editorStatus.selectedArtboardIds &&
        editorStatus.selectedArtboardIds.length > 0
      ) {
        editorStatus.selectedArtboardIds.map((id: string) => {
          ids = [...ids, id];
        });
      } else if (
        context.data[0]?.children &&
        context.data[0]?.children.length > 0
      ) {
        context.data[0].children.map((child: IElement) => {
          ids = [...ids, child.id];
        });
      }
      handleAddBrandImage(ids, imageBrandInfo);
    } else {
      handleAddBrandImage([context.data[0].id], imageBrandInfo);
    }
  };

  const handleAddBrandImage = (
    ids: string[],
    imageBrandInfo: IBrandImage,
    coors?: { x: number; y: number },
    elementCoors?: { x: number; y: number }
  ) => {
    try {
      let newImageElements: IElement[] = [];
      let imageWidth = imageBrandInfo.initWidth ?? 200;
      let imageHeight = imageBrandInfo.initHeight ?? 200;
      const originalWidth = imageWidth,
        originalHeight = imageHeight;
      let elementIds: string[] = [];
      ids.map((id) => {
        const imageElementId = uuid();
        let parentElement: IElement | undefined = findElementById(
          context.data,
          id
        );
        if (parentElement === undefined) parentElement = context.data[0];
        const recalculatedSizes = getBoundingsWithDelta(
          deltaBorder,
          originalWidth,
          originalHeight,
          parentElement.attributes.width,
          parentElement.attributes.height
        );
        imageWidth = recalculatedSizes.width;
        imageHeight = recalculatedSizes.height;
        let coorX = parentElement.attributes.x;
        let coorY = parentElement.attributes.y;
        if (coors && elementCoors) {
          coorX +=
            coors.x * parentElement.attributes.width -
            elementCoors.x * imageWidth;
          coorY +=
            coors.y * parentElement.attributes.height -
            elementCoors.y * imageHeight;
        } else {
          coorX += parentElement.attributes.width / 2 - imageWidth / 2;
          coorY += parentElement.attributes.height / 2 - imageHeight / 2;
        }
        const newAtributes: IImageAttributes = {
          x: coorX,
          y: coorY,
          width: imageWidth,
          height: imageHeight,
          srcImage: imageBrandInfo.srcImage,
          brandId: imageBrandInfo.brandId,
          brandImageType: imageBrandInfo.imageType,
          hidden: false,
          image: { x: coorX, y: coorY, width: imageWidth, height: imageHeight },
        };
        const newImageElement: IElement = {
          id: imageElementId,
          name: imageElementId,
          type: "Image",
          attributes: newAtributes,
        };
        newImageElements = [...newImageElements, newImageElement];
        elementIds = [...elementIds, imageElementId];
      });

      context.onCommandChange("addElement", undefined, ids, newImageElements);
      onShowSearchImages(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleReplaceBrandImage = (data: IBrandImage) => {
    try {
      const srcImage = uuid();
      let url = `${urlFiles}/${data.srcImage}`;
      if (data.brandId !== undefined && data.brandId !== null)
        url = `${urlBrand}/${data.brandId}/${data.imageType.toLowerCase()}/${
          data.srcImage
        }`;

      const urls = {
        oldSrc: data.srcImage,
        newSrc: `${context.parsedTreeInfo.id}/${srcImage}.png`,
      };
      let imageWidth = data.initWidth ?? 200;
      let imageHeight = data.initHeight ?? 200;
      const ids: string[] = context.editorStatus.selectedElementsId;

      const values = Array(ids.length).fill({
        srcImage: urls.oldSrc,
        width: imageWidth,
        height: imageHeight,
        newSrcImage: srcImage,
        brandId: data.brandId,
        brandImageType: data.imageType,
        hidden: false,
      });

      context.onCommandChange("srcImage", undefined, ids, values);
      onShowSearchImages(false);
    } catch (error) {
      console.error(error);
    }
  };

  async function getImage(brandImage: IBrandImage) {
    setLoadingImage(true);
    const data: any = await getExternalImage(brandImage.srcImage);
    if (data) {
      let url = `${urlFiles}/${data}`;
      var img = new Image();
      img.src = url;
      img.onload = (e) => {
        brandImage.initHeight = img.height;
        brandImage.initWidth = img.width;
        brandImage.srcImage = data;
        handleAddBrandImageManager(brandImage);
      };
    }
  }

  const getExternalImage = (url: string) => {
    return new Promise((resolve, reject) => {
      dispatch(
        actions.brandsImages.getExternalImage(url, (result, error) => {
          if (error) reject(error);
          else {
            resolve(result);
          }
        })
      );
    });
  };
  ///End brand images select functions

  return (
    <S.Root>
      {galleryPanel ? (
        <S.GalleryPanelContainer>
          <S.GalleryMessage>
            Which dealer would you like to open Media Gallery assets for?
          </S.GalleryMessage>
          <S.GalleryDropDownContainer>
            <DealerSelect />
            {showMediaGallery && (
              <MediaGallery
                dealerId={dealers.selectedDealer?.id ?? ""}
                dealerURL={dealers.selectedDealer?.url ?? ""}
                allowMultipleSelection={true}
                onMediaGalleryClose={onMediaGalleryClose}
              ></MediaGallery>
            )}
          </S.GalleryDropDownContainer>
          <S.GalleryButtonsContainer>
            <Button
              label={`CANCEL`}
              style={{
                width: `109px`,
                boxSizing: `border-box`,
                border: `1px solid ${C.DARK_BLUE}`,
                backgroundColor: "transparent",
                hoverBackgroundColor: `${C.DARK_BLUE}22`,
              }}
              labelStyle={{ color: C.DARK_BLUE }}
              onClick={() => setGalleryPanel(false)}
            />
            <Button
              label={`OPEN`}
              style={{
                width: `109px`,
                boxSizing: `border-box`,
                backgroundColor: `${C.DARK_BLUE}`,
                hoverBackgroundColor: "#344a70",
              }}
              disabled={dealers.selectedDealer ? false : true}
              labelStyle={{ color: C.WHITE }}
              onClick={() => {
                if (dealers.selectedDealer) setShowMeadiaGallery(true);
              }}
            />
          </S.GalleryButtonsContainer>
        </S.GalleryPanelContainer>
      ) : (
        <S.PanelContainer>
          <input
            ref={fileInputRef}
            id="fileInput"
            type="file"
            style={{ display: "none" }}
            onChange={onInputFileChange}
            accept={imageFileTypes.join()}
            multiple={true}
          />
          {replace && !props.multiediting && (
            <S.ReplaceMessage>Select an image to replace.</S.ReplaceMessage>
          )}
          <S.ButtonPanel>
            <S.ButtonContainer>
              <Button
                label={`UPLOAD`}
                style={{
                  width: `188px`,
                  boxSizing: `border-box`,
                  backgroundColor: "transparent",
                  borderRadius: `5px`,
                  hoverBackgroundColor: "#344a70",
                }}
                labelStyle={{ color: C.WHITE }}
                onClick={handleUploadFile}
              />
              <S.ButtonDivider />
              <S.ButtonOptionsIcon onClick={handleOpenOptions}>
                <S.ButtonOptionsIconScale>
                  <OptionIcon style={{ fillColor: C.WHITE }} />
                </S.ButtonOptionsIconScale>
              </S.ButtonOptionsIcon>
              {openOptions && (
                <S.ButtonOptionsContainer>
                  <S.ButtonOption onClick={handleUploadFromPanel}>
                    Upload from my Device
                  </S.ButtonOption>
                  <S.ButtonOption onClick={() => setGalleryPanel(true)}>
                    Upload from Media Gallery
                  </S.ButtonOption>
                  <S.ButtonOption
                    onClick={() => handleUploadFromBrandLibrary()}
                  >
                    Upload from Brand Library
                  </S.ButtonOption>
                </S.ButtonOptionsContainer>
              )}
            </S.ButtonContainer>
          </S.ButtonPanel>
          <Tabs
            options={TabOptions}
            value={panelValue}
            setValue={setPanelValue}
            containerStyle={{
              padding: `0px 18px`,
              boxSizing: `border-box`,
            }}
            tabStyle={{
              fontSize: `13px`,
            }}
            sizes={{
              tabWidth: 113,
              barWidth: 97,
            }}
          />
          {context.userFiles?.files?.length && imageListFiltered.length > 0 ? (
            <>
              <S.SelectAllContainer>
                <input
                  type="checkbox"
                  checked={
                    selectedImages !== null &&
                    selectedImages.length > 0 &&
                    selectedImages.length === imageListFiltered.length
                  }
                  onChange={handleSelectAllImages}
                />
                <label htmlFor="select-all">Select all</label>
              </S.SelectAllContainer>
              <S.ListContainer>
                {imageListFiltered.map((image, index) => (
                  <DragElement key={index} id={image.id} type="Image">
                    {renderListComponent(image, index)}
                  </DragElement>
                ))}
              </S.ListContainer>
              {selectedImages && selectedImages.length > 0 && (
                <S.DeleteButton
                  disabled={!selectedImages || selectedImages.length === 0}
                  onClick={() => {
                    if (selectedImages.length > 0) {
                      setIsModalOpen(true);
                    }
                  }}
                >
                  DELETE SELECTED IMAGES
                </S.DeleteButton>
              )}
              <DeleteConfirmationModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={() => deleteBulkFiles(selectedImages)}
                selectedImagesCount={selectedImages?.length??0}
              />
            </>
          ) : (
            <S.DnDContainer>
              <S.DndBox
                dragging={dragging}
                onDrop={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  ondrop(e);
                }}
                onDragOver={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setDragging(true);
                }}
                onDragExit={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setDragging(false);
                }}
                onDragLeave={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setDragging(false);
                }}
                onDragEnd={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setDragging(false);
                }}
              >
                <S.DnDText>
                  Upload a file from your device or drag and drop files here
                </S.DnDText>
              </S.DndBox>
            </S.DnDContainer>
          )}
        </S.PanelContainer>
      )}
      {context.searchImages && (
        <SearchImages
          open={context.searchImages}
          setOpen={(show: boolean) => {
            context.onShowSearchImages(show);
          }}
          onSelect={(data: IBrandImage) => {
            handleSelectImage(data);
          }}
          category={undefined}
          loadingImage={loadingImage}
        />
      )}
    </S.Root>
  );

  function onMediaGalleryClose(imgUrls: string[]) {
    setShowMeadiaGallery(false);
    if (imgUrls.length > 0) {
      setFilesUrl(imgUrls);
      setPanelValue("Media Gallery");
      setGalleryPanel(false);
    }
  }
};

export default ImagePicker;
